/**
 * Animated number counter — uses GSAP to tween a target value and updates an element.
 */
import { gsap } from 'gsap'

export function animateCounter(
  el: HTMLElement,
  target: number,
  opts: { duration?: number; prefix?: string; suffix?: string; decimals?: number } = {},
): void {
  const { duration = 1.8, prefix = '', suffix = '', decimals = 0 } = opts
  const state = { value: 0 }
  gsap.to(state, {
    value: target,
    duration,
    ease: 'power2.out',
    onUpdate() {
      const rounded = decimals > 0 ? state.value.toFixed(decimals) : Math.floor(state.value).toString()
      el.textContent = `${prefix}${rounded}${suffix}`
    },
  })
}

/** Mount counters on [data-counter] elements; triggers when they enter viewport. */
export function mountCounters(): void {
  const targets = Array.from(document.querySelectorAll<HTMLElement>('[data-counter]'))
  if (targets.length === 0) return

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return
        const el = entry.target as HTMLElement
        observer.unobserve(el)
        const target = Number(el.dataset.counter ?? 0)
        const duration = Number(el.dataset.counterDuration ?? 1.8)
        animateCounter(el, target, { duration })
      })
    },
    { threshold: 0.3, rootMargin: '0px 0px -10% 0px' },
  )

  targets.forEach((el) => {
    el.textContent = '0'
    observer.observe(el)
  })
}
